export const getStoreInfoPayload = ({ contactEmail, defaultLanguage, supportedLanguages, storeId, contactUrl }) => {
  return {
    storeId: storeId,
    params: {
      contact_email: contactEmail,
      default_language: defaultLanguage,
      supported_languages: supportedLanguages,
      contact_url: contactUrl?.length > 0 ? contactUrl : null,
    },
  }
}

export const getPortalFeaturesPayload = ({ returnPortalId, returnsPolicyUrl, helpCenterUrl }) => {
  return {
    returnPortalId,
    payload: {
      returns_policy_url: returnsPolicyUrl?.length > 0 ? returnsPolicyUrl : null,
      help_center_url: helpCenterUrl?.length > 0 ? helpCenterUrl : null,
    },
  }
}

export const updateContextStoreInfo = ({
  contactEmail,
  supportedLanguages,
  defaultLanguage,
  updateContext,
  contact_url,
}) => {
  updateContext(info => ({
    ...info,
    selectedStore: {
      ...info.selectedStore,
      default_language: defaultLanguage,
      supported_languages: supportedLanguages,
      contact_email: contactEmail,
      contact_url: contact_url,
    },
    stores: info.stores.map(s => ({
      ...s,
      contact_email: info.selectedStore.id === s.id ? contactEmail : s.contact_email,
      default_language: info.selectedStore.id === s.id ? defaultLanguage : s.default_language,
      supported_languages: info.selectedStore.id === s.id ? supportedLanguages : s.supported_languages,
      contact_url: info.selectedStore.id === s.id ? contact_url : s.contact_url,
    })),
  }))
}

export const updateLocalStorageStoreInfo = ({ contactEmail, supportedLanguages, defaultLanguage }) => {
  if (localStorage.selectedStore) {
    let newSelectedStore = JSON.parse(localStorage.selectedStore)
    newSelectedStore.contact_email = contactEmail
    newSelectedStore.supported_languages = supportedLanguages
    newSelectedStore.default_language = defaultLanguage
    localStorage.selectedStore = JSON.stringify(newSelectedStore)
  }
}
